import styled from "styled-components";
import Link from "next/link";
import {getColor} from "@/styles/ThemeConfig";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const Wrapper = styled.div`
    width: calc(100% - 30px);
    position: relative;
    gap:20px;
    //padding:15px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${getColor("greenText")};
    padding-bottom:15px;
`

const LinkItem = styled(ForceSSRLink)`
    color:${getColor('greenText')};
    font-size: 14px;

    text-decoration: none;
`
const RedButton = styled(ForceSSRLink)`
    color:${getColor('greenText')};

    text-transform: uppercase;
    text-decoration: none;
`
const Dropdown = styled.div`
    position: relative;
    font-size: 14px;

    color:${getColor('greenText')};

    text-transform: capitalize;
    gap: 5px;
    cursor: pointer;
    overflow: visible;
`


const DropdownOptionsWrapper = styled.div`
    font-size: 14px;

    margin-left: 20px;

    display: flex;
    flex-direction: column;
    margin-top: 10px;
    gap:10px;

    a{
        color: ${getColor('greenText')};
        text-decoration: none;
    }
`
export default function CustomDropdownHeaderMobile({items, setShowMenu})
{
    function renderItem(item, index) {
        // Check if item_link is #FAQ or #BOOKING
        const handleClick = (link) => {
            if (link === "#FAQ" || link === "#BOOKING" || link === "#CONTACT") {
                setShowMenu(false);  // Close the menu
            }
        };

        switch (item?.item_type) {
            case 'link':
                return (
                    <LinkItem key={index} href={item?.item_link ?? '#'} onClick={() => handleClick(item?.item_link)}>
                        {item?.item_title}
                    </LinkItem>
                );
            case 'red_button':
                return (
                    <RedButton key={index} href={item?.item_link ?? '#'} onClick={() => handleClick(item?.item_link)}>
                        {item?.item_title}
                    </RedButton>
                );
            case 'dropdown':
                return (
                    <Dropdown key={index}>
                        <div
                            onClick={() => handleOpenDropdown(index)}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            {item?.item_title}:
                        </div>
                        <DropdownOptionsWrapper className={'dropdown_items'}>
                            {
                                item?.dropdown_items?.map((dropdownItem, index) => {
                                    const link = dropdownItem?.item_link ?? '#';
                                    return (
                                        <ForceSSRLink
                                            key={index}
                                            href={link}
                                            onClick={() => handleClick(link)}
                                        >
                                            {dropdownItem?.tour
                                                ? decodeURIComponent(dropdownItem?.tour?.split('|')?.[0].replace(/\+/g, ' '))
                                                : dropdownItem?.item_title}
                                        </ForceSSRLink>
                                    );
                                })
                            }
                        </DropdownOptionsWrapper>
                    </Dropdown>
                );
            default:
                return null;
        }
    }



    return <Wrapper>
                {items?.map((item,index) => renderItem(item,index))}
    </Wrapper>
}
